// extracted by mini-css-extract-plugin
export default {"menuBlock":"rF-z","title":"sF-z","nav":"tF-z","flexCell":"uF-z","facetLink":"vF-z"};